<main>
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
  />
  <ng-container *ngIf="!loading; else loadingTemplate">
    <div [ngSwitch]="pageData?.id">
      <!-- Custom Component for handling my requests-->
      <div *ngSwitchCase="'inProgressRequestsId'">
        <app-my-requests></app-my-requests>
      </div>

      <!-- Custom Component for handling onboarding requests-->
      <div *ngSwitchCase="'onboardingRequestId'">
        <app-onboarding-requests></app-onboarding-requests>
      </div>

      <!-- Custom Component for handling update transit time requests-->
      <div *ngSwitchCase="'updateTransitTimeRequestId'">
        <app-update-requests></app-update-requests>
      </div>

      <!-- Update Validation threshold for Auto Approval -->
      <div *ngSwitchCase="'updateValidationThresholdId'">
        <app-update-validation-threshold></app-update-validation-threshold>
      </div>

      <!-- Custom Component for viewing active versions-->
      <div *ngSwitchCase="'changeTransitTimeConfigurationId'">
          <app-configure-transit-time-requests></app-configure-transit-time-requests>
      </div>

      <!-- Custom Component for handling previous requests-->
      <div *ngSwitchCase="'pendingApprovalRequestsId'">
          <app-pending-approval-requests></app-pending-approval-requests>
      </div>

      <!-- Custom Component for handling previous requests-->
      <div *ngSwitchCase="'viewPreviousRequestId'">
          <app-previous-requests></app-previous-requests>
      </div>

      <!-- Custom Component for changing transit time active version-->
      <div *ngSwitchCase="'changeTransitTimeActiveVersionId'">
          <app-change-active-version-requests></app-change-active-version-requests>
      </div>

      <!-- Custom Component for updating transit time overrides-->
      <div *ngSwitchCase="'updateTransitTimeOverridesId'">
          <app-update-transit-time-overrides></app-update-transit-time-overrides>
      </div>

      <!-- Custom Component for transit time configuration self-serve (admin only)-->
      <div *ngSwitchCase="'transitTimeConfigurationId'">
          <ng-container *ngIf="checkAdminPermission; else transitTimeConfigNoAccess">
            <app-transit-time-configuration></app-transit-time-configuration>
          </ng-container>
      </div>

      <!-- Custom Component for transit time self serve access management-->
      <div *ngSwitchCase="'managePermissionsId'">
          <ng-container *ngIf="checkAdminPermission; else noAccess">
            <app-manage-permissions-wrapper></app-manage-permissions-wrapper>
          </ng-container>
      </div>

      <!-- Custom Component for transit time self serve request permissions-->
      <div *ngSwitchCase="'requestPermissionsId'">
          <app-request-permissions></app-request-permissions>
      </div>

      <!-- Custom Component for help-->
      <div *ngSwitchCase="'helpId'">
        <app-help></app-help>
      </div>

      <!-- Default RESTool Handling-->
      <div *ngSwitchDefault>
        <app-get
          [pageData]="pageData"
          (stateChanged)="showPopup($event)"
        ></app-get>
        <put-dialog
          [visible]="popupState === 'put' && !loading"
          (stateChanged)="showPopup($event)"
          [(rowData)]="selectedRow"
          [pageData]="pageData"
        ></put-dialog>
        <post-dialog
          [visible]="popupState === 'post'"
          (stateChanged)="showPopup($event)"
          [pageData]="pageData"
        ></post-dialog>
      </div>
    </div>
  </ng-container>
</main>

<ng-template #loadingTemplate>
  <app-loader [loading]="true" [size]="'small'"></app-loader>
</ng-template>
<ng-template #noAccess>
  <div class="no-access-message">
    Looks like you do not have the permission to access this page, please send
    an email with the page name you want access to navic-devs@amazon.com.
  </div>
</ng-template>
<ng-template #transitTimeConfigNoAccess>
  <div>
    <div class="pure-menu pure-menu-horizontal">
      <a href="" onClick="return false;" class="pure-menu-heading pure-menu-link">Transit Time Configuration</a>
    </div>
    <div class="container">
      <p style="line-height: 22px; margin-bottom: 16px;">
        This page lets the dev team view transit time configuration records &mdash; the parent ship
        methods for a business unit and country, their transit time type, and the child ship methods
        mapped to each &mdash; and update a parent's <strong>mapped services</strong> directly from the
        UI instead of editing the DynamoDB table by hand. Every change is attributed to the logged-in
        user and audited. Select a From Country Code and Business Use Case to load the records, then
        use <strong>Edit</strong> on a row to add or remove its mapped child ship methods.
      </p>
      <div class="no-access-message">
        Looks like you do not have the permission to access this page, please send
        an email with the page name you want access to navic-devs@amazon.com.
      </div>
    </div>
  </div>
</ng-template>
